<table mat-table [dataSource]="dataSource" matSort style="width: 100%;" matSortActive="creationDate"
  matSortDirection="desc">

  <!-- date Column -->
  <ng-container matColumnDef="date">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.site' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.date | date : 'dd/MM/yy'}}</span>
    </td>
  </ng-container>

  <!-- quantity Column -->
  <ng-container matColumnDef="quantity">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.quantity' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.quantity | number :'0.0' :'fr' }} </span>
    </td>
  </ng-container>

  <!-- measureUnit Column -->
  <ng-container matColumnDef="measureUnit">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.measureUnit' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.measureUnit }} </span>
    </td>
  </ng-container>

  <!-- shipName Column -->
  <ng-container matColumnDef="shipName">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.ship' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.shipName }} </span>
    </td>
  </ng-container>

  <!-- origineName Column -->
  <ng-container matColumnDef="origineName">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.from' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.origineName }} </span>
    </td>
  </ng-container>

  <!-- destinationName Column -->
  <ng-container matColumnDef="destinationName">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.to' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.destinationName }} </span>
    </td>
  </ng-container>

  <!-- orderReference Column -->
  <ng-container matColumnDef="orderReference">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.order-reference' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.orderReference }} </span>
    </td>
  </ng-container>

  <!-- material Column -->
  <ng-container matColumnDef="material">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.material' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.material?.name }} </span>
    </td>
  </ng-container>

  <!-- gsin Column -->
  <ng-container matColumnDef="gsin">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.gsin' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.gsin }} </span>
    </td>
  </ng-container>

  <!-- plannedDeliveryDate Column -->
  <ng-container matColumnDef="plannedDeliveryDate">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.plannedDeliveryDate' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.plannedDeliveryDate | date : 'dd/MM/yy'}}</span>
    </td>
  </ng-container>

  <!-- plannedDespatchDate Column -->
  <ng-container matColumnDef="plannedDespatchDate">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.plannedDespatchDate' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.plannedDespatchDate | date : 'dd/MM/yy'}}</span>
    </td>
  </ng-container>


  <!-- st4wIdentifier Column -->
  <ng-container matColumnDef="st4wIdentifier">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.st4wIdentifier' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.st4wIdentifier }}</span>
    </td>
  </ng-container>


  <!-- updateDate Column -->
  <ng-container matColumnDef="updateDate">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.updateDate' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.updateDate | date : 'dd/MM/yy'}}</span>
    </td>
  </ng-container>


  <!-- pickupDate Column -->
  <ng-container matColumnDef="pickupDate">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.pickupDate' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.pickupDate | date : 'dd/MM/yy'}}</span>
    </td>
  </ng-container>


  <!-- enRouteDate Column -->
  <ng-container matColumnDef="enRouteDate">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.enRouteDate' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.enRouteDate | date : 'dd/MM/yy'}}</span>
    </td>
  </ng-container>


  <!-- dropoffDate Column -->
  <ng-container matColumnDef="dropoffDate">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.dropoffDate' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.dropoffDate | date : 'dd/MM/yy'}}</span>
    </td>
  </ng-container>

  <!-- creationDate Column -->
  <ng-container matColumnDef="creationDate">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.creation' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.creationDate | date : 'dd/MM/yy HH:mm'}}</span>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'highlight': selectedRowID == row.id}"
    (click)="selectItemClick(row)"></tr>
</table>
<mat-paginator class="m-5 mat-elevation-z2" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons>
</mat-paginator>